/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `person` - person
 * * `business` - business
 */
export type EntityKindEnum = (typeof EntityKindEnum)[keyof typeof EntityKindEnum];

export const EntityKindEnum = {
    person: 'person',
    business: 'business',
} as const;
